import TemplateChecklistView from './TemplateChecklistView';

export default TemplateChecklistView;
